import { t } from '../../app/i18n';

export default {
  ZAKLADNE: 'ZAKLADNE',
  STREDOSKOLSKE_BEZ_MATURITY: 'STREDOSKOLSKE_BEZ_MATURITY',
  STREDOSKOLSKE_S_MATURITOU: 'STREDOSKOLSKE_S_MATURITOU',
  NADSTAVBOVE: 'NADSTAVBOVE',
  VYSOKOSKOLSKE_1: 'VYSOKOSKOLSKE_1',
  VYSOKOSKOLSKE_2: 'VYSOKOSKOLSKE_2',
  VYSOKOSKOLSKE_3: 'VYSOKOSKOLSKE_3',
};

export const translation = {
  ZAKLADNE: t('základné vzdelanie'),
  STREDOSKOLSKE_BEZ_MATURITY: t('stredoškolské bez maturity'),
  STREDOSKOLSKE_S_MATURITOU: t('stredoškolské s maturitou'),
  NADSTAVBOVE: t('nadstavbové/vyššie odborné vzdelanie'),
  VYSOKOSKOLSKE_1: t('vysokoškolské I. stupňa'),
  VYSOKOSKOLSKE_2: t('vysokoškolské II. stupňa'),
  VYSOKOSKOLSKE_3: t('vysokoškolské III. stupňa'),
};



// WEBPACK FOOTER //
// ./src/common/enums/education.js